import { createFileRoute } from '@tanstack/react-router'
import { store } from '@/state/breadcrumb-store'

export const Route = createFileRoute('/customer/')({
  component: RouteComponent,
})

import { CustomerDashboard } from "@/components/customer/dashboard"


function RouteComponent() {
  store.trigger.changePath({
    newPath:
      [{ params: {}, to: "/customer", label: "Customer" }]
  })
  return <CustomerDashboard></CustomerDashboard>
}
